import React, { useState, useEffect } from 'react';
import { PrimaryButton } from "../../UI";
import SuccessAlert from '../../UI/Alert/SuccessAlert';
import ErrorAlert from '../../UI/Alert/ErrorAlert';
import { useUserContext } from '../../../contexts/UserContext';
import { updateOrganizations } from '../../../utils/APIs';
import Loader from '../Loader/Loader';
import Input from '../Input';
import { useContentfulContext } from '../../../contexts/ContentfulContext';

const RenameOrganisationForm = ( { selectedOrganisation, setSelectedOrganisation } ) => {
    const { userData, setUserData } = useUserContext();
    const { content } = useContentfulContext();

    const [companyName, setCompanyName] = useState("");
    const [companyValid, setCompanyValid] = useState(false);
    const [updateSuccess, setUpdateSuccess] = useState(false);
    const [updateError, setUpdateError] = useState("")
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (companyName == selectedOrganisation?.display_name || companyName.length < 1) {
            setCompanyValid(false);
        } else {
            setCompanyValid(true);
        }
    }, [companyName]);

    useEffect(() => {
        setCompanyName(selectedOrganisation?.display_name);
    }, [selectedOrganisation]);

    const handleSaveChanges = async () => {
        try {
            setLoading(true)
            const result = await updateOrganizations(userData.token, selectedOrganisation.org_token, { name: companyName });
            setSelectedOrganisation((prev) => {
                return {
                    ...prev,
                    display_name: result.data.display_name
                }
            });
            setCompanyName(result.data.display_name);
            result && setLoading(false)
            setUpdateSuccess(true);
            const updatedOrg = userData.organizations.map((x) =>
              x.name === result.data.name
                ? {
                    ...x,
                    name: result.data.name,
                    display_name: result.data.display_name,
                  }
                : x
            );
            setUserData((prev) => ({
                ...prev,
                organizations: updatedOrg,
                selectedOrganization: {
                    ...prev.selectedOrganization,
                    name: result.data.name,
                    display_name: result.data.display_name,
                }
            }))
        } catch (error) {
            setLoading(false)
            console.log("error", error);
            setUpdateError(error?.response?.data?.message)
        }
    };

    return (
       <>
       {loading && <Loader/>}
        <div className='mb-6'>
            { updateError && <ErrorAlert timeout={content.RENAME_ORGANISATION_CONTENT.error_alert.timeout}>{updateError}</ErrorAlert>}
            { updateSuccess && <SuccessAlert disappearTime={content.RENAME_ORGANISATION_CONTENT.success_alert.timeout} >{content.RENAME_ORGANISATION_CONTENT.errors.FE132}</SuccessAlert> }
            <Input
                name="company"
                id="company"
                label={content.RENAME_ORGANISATION_CONTENT.formLabels.organisation}
                value={companyName}
                onChange={(e) => { setCompanyName(e.target.value) }}
                className="mb-4"
            />
            <PrimaryButton handleClick={handleSaveChanges} disable={!companyValid} >
                {content.RENAME_ORGANISATION_CONTENT.formLabels.cta_text}
            </PrimaryButton>
        </div>
       </>
    )
}

export default RenameOrganisationForm;